import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRefPolymorphic } from "@datamole/wds-std";
import clsx from "clsx";
import styles from "./button.module.css";
import { ButtonContext } from "./context";
import { DEFAULT_ELEMENT_TYPE, DEFAULT_SIZE, DEFAULT_VARIANT } from "./utils";
const Button = (props, ref) => {
    const { as, children, className, size = DEFAULT_SIZE, variant = DEFAULT_VARIANT, ...otherProps } = props;
    const Component = as ?? DEFAULT_ELEMENT_TYPE;
    const isButtonElement = !as || as === DEFAULT_ELEMENT_TYPE;
    const defaultButtonProps = {
        ...(isButtonElement && { type: "button" }),
    };
    return (_jsx(ButtonContext.Provider, { value: {
            size,
            variant,
        }, children: _jsx(Component, { ref: ref, className: clsx(styles.button, className), "data-variant": variant, "data-size": size, ...defaultButtonProps, ...otherProps, children: children }) }));
};
Button.displayName = "Button";
const ButtonWithPolymorphicRef = forwardRefPolymorphic(Button);
export { ButtonWithPolymorphicRef as Button };
